import { render, staticRenderFns } from "./CarShakeDetect.vue?vue&type=template&id=5d1aa398&scoped=true"
import script from "./CarShakeDetect.vue?vue&type=script&lang=js"
export * from "./CarShakeDetect.vue?vue&type=script&lang=js"
import style0 from "./CarShakeDetect.vue?vue&type=style&index=0&id=5d1aa398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1aa398",
  null
  
)

export default component.exports